import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { StorageService } from '../../utils/storage/storage.service';
import Swal from 'sweetalert2';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-token',
    templateUrl: './token.component.html',
    styleUrls: ['./token.component.scss']
})
export class TokenComponent {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private storageService: StorageService) { }

    ngOnInit(): void {
        // Extract the token from the route parameters
        this.route.paramMap.subscribe(async (params: any) => {
            const shortToken = params.get('token');
            if (shortToken) {
                this.authService.authorizeShortToken(shortToken)
                    .subscribe(
                        async (res: any) => {
                            if (res && res.data && res.data.authorization && res.data.authorization.token) {
                                const token = res.data.authorization.token;
                                const user = res.data.user;

                                await this.storageService.setString(environment.config.tokenKey, token);
                                this.storageService
                                    .setObject(environment.config.userKey, user)
                                    .then(() => this.router.navigate(['/']));
                            }
                            else {
                                Swal.fire({
                                    title: helper.dialogConfig.headers.errorAtentie,
                                    text: 'Nu s-a putut valida token-ul. Contactati echipa de suport.',
                                    icon: 'error',
                                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                                    showCancelButton: false,
                                    allowOutsideClick: false,
                                })
                                    .then(() => this.authService.redirectToLogin())
                            };
                        },
                        (err: any) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }

                            Swal.fire({
                                title: helper.dialogConfig.headers.errorAtentie,
                                text: msg,
                                icon: 'error',
                                confirmButtonText: helper.dialogConfig.buttonLabels.close,
                                showCancelButton: false,
                                allowOutsideClick: false,
                            }).then(() => this.authService.redirectToLogin());

                            return false;
                        }
                    );
            } else {
                this.authService.redirectToLogin();
            }
        });
    }

    // ngOnInit(): void {
    //     // Extract the token from the route parameters
    //     this.route.paramMap.subscribe(async (params: any) => {
    //         const token = params.get('token');
    //         if (token) {
    //             console.log('Token received : ', token);
    //             // You can now work with the token
    //             this.authService.verifyToken(token)
    //                 .subscribe(async (res: boolean) => {
    //                     if (res) {
    //                         await this.storageService.setString(environment.config.tokenKey, token)
    //                         this.authService.getUserDetails(token)
    //                             .subscribe(async (res: any) => {
    //                                 const user = res.data.user;
    //                                 console.log('Fetched user data : ', user);
    //                                 this.storageService.setObject(environment.config.userKey, user)
    //                                     .then(() => this.router.navigate(['/']));
    //                             });
    //                     }
    //                 })
    //         }
    //         else {
    //             this.authService.redirectToLogin();
    //         }
    //     });
    // }
}
